<template>
  <div class="shipment_land">
    <div class="px-2 px-lg-5">
      <div class="p-4">
        <!--title -->
        <h2 class="h2 text-center font-weight-bold">
          Land Shipment Details
        </h2>
        <!-- order details -->
        <div class="font-weight-bold mb-2 mt-4">
          Orders Details
        </div>
        <!-- created date s.d fleet type -->
        <b-row class="mb-4">
          <!-- created date -->
          <b-col md="2">
            <p class="mb-1">Created Date</p>
            <b-input-group>
              <b-form-input
                :value="getDate(today)"
                type="date"
                name="created-date"
                readonly
              />
            </b-input-group>
          </b-col>
          <!-- departure date -->
          <b-col md="2">
            <p class="mb-1">
              Departure Date <span class="text-danger">*</span>
            </p>
            <b-input-group>
              <b-form-input
                v-model="form.tmsDepartureTime"
                type="datetime-local"
                name="date"
                :min="getMinimumToday()"
                v-validate="'required'"
                @keydown="() => false"
              />
            </b-input-group>
            <div
              v-if="error.tmsDepartureTime"
              class="text-left input-group __input"
            >
              <small class="text-danger">Required</small>
            </div>
          </b-col>
          <!-- cod amount -->
          <b-col md="2">
            <p class="mb-1">COD Amount</p>
            <b-input-group class="input__money">
              <money
                class="__money"
                :class="form.tmsCodAmount === 0 ? 'init_value' : ''"
                v-model="form.tmsCodAmount"
                :value="form.tmsCodAmount"
              ></money>
            </b-input-group>
          </b-col>
          <!-- fleet category -->
          <b-col md="3" class="input__model1group input__model1group--dropdown">
            <p class="mb-1">
              Fleet Category <span class="text-danger">*</span>
            </p>
            <div class="options__defaultdropdown">
              <b-dropdown>
                <template #button-content>
                  <p>{{ form.tmsFleetCategory || 'Select Fleet Category' }}</p>
                </template>
                <b-dropdown-item
                  v-for="(unit, y) in fleetCategoryDropdown"
                  :key="y"
                  @click="handleChange('tmsFleetCategory', unit)"
                >
                  {{ unit.name }}
                </b-dropdown-item>
              </b-dropdown>
              <img
                class="imgabsolute"
                style="right: 24px;"
                src="@/assets/image/image/gray-down-arrow@3x.png"
              />
            </div>
            <div
              v-if="error.tmsFleetCategory"
              class="text-left input-group __input"
            >
              <small class="text-danger">Required</small>
            </div>
          </b-col>
          <!-- fleet type -->
          <b-col md="3" class="input__model1group input__model1group--dropdown">
            <p class="mb-1">Fleet Type <span class="text-danger">*</span></p>
            <div class="options__defaultdropdown">
              <b-dropdown
                :disabled="!form.tmsFleetCategory || isLoadingFleetType"
              >
                <template #button-content>
                  <p>{{ form.tmsFleetType || 'Select Fleet Type' }}</p>
                </template>
                <b-dropdown-item
                  v-for="(unit, y) in fleetTypeDropdown"
                  :key="y"
                  @click="form.tmsFleetType = unit.name"
                >
                  {{ unit.name }}
                </b-dropdown-item>
              </b-dropdown>
              <img
                class="imgabsolute"
                style="right: 24px;"
                src="@/assets/image/image/gray-down-arrow@3x.png"
              />
            </div>
            <div
              v-if="error.tmsFleetType"
              class="text-left input-group __input"
            >
              <small class="text-danger">Required</small>
            </div>
          </b-col>
        </b-row>
        <!-- divider -->
        <hr class="w-100 border-secondary my-5" />
        <div class="font-weight-bold mb-2">
          Origin and Destination
        </div>
        <b-row class="mb-4">
          <!-- origin -->
          <b-col md="4" class="input__model1group input__model1group--dropdown">
            <p class="mb-1">Origin <span class="text-danger">*</span></p>
            <div class="options__defaultdropdown">
              <b-dropdown>
                <template #button-content>
                  <p>{{ form.tmsOrigin || 'Select Origin' }}</p>
                </template>
                <b-dropdown-item
                  v-for="(unit, y) in originCustomerDropdown"
                  :key="y"
                  @click="handleChange('tmsOrigin', unit)"
                >
                  {{ unit.name }}
                </b-dropdown-item>
              </b-dropdown>
              <img
                class="imgabsolute"
                style="right: 24px;"
                src="@/assets/image/image/gray-down-arrow@3x.png"
              />
            </div>
            <div v-if="error.tmsOrigin" class="text-left input-group __input">
              <small class="text-danger">Required</small>
            </div>
          </b-col>
          <!-- destination -->
          <b-col md="4" class="input__model1group input__model1group--dropdown">
            <p class="mb-1">Destination <span class="text-danger">*</span></p>
            <div class="options__defaultdropdown">
              <b-dropdown>
                <template #button-content>
                  <p>{{ form.tmsDestination || 'Select Destination' }}</p>
                </template>
                <b-dropdown-item
                  v-for="(unit, y) in destinationCustomerDropdown"
                  :key="y"
                  @click="handleChange('tmsDestination', unit)"
                >
                  {{ unit.name }}
                </b-dropdown-item>
              </b-dropdown>
              <img
                class="imgabsolute"
                style="right: 24px;"
                src="@/assets/image/image/gray-down-arrow@3x.png"
              />
            </div>
            <div
              v-if="error.tmsDestination"
              class="text-left input-group __input"
            >
              <small class="text-danger">Required</small>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'FormShipmentLand',
  props: {
    submitCheck: Boolean
  },
  data() {
    return {
      // new
      form: {
        // order details
        serviceHead: 'LAND',
        tmsDepartureTime: '',
        tmsCodAmount: '',
        tmsFleetCategory: '',
        tmsFleetType: '',
        // origin and destination
        tmsOrigin: '',
        tmsDestination: '',
        tmsOriginCity: '',
        tmsDestinationCity: '',
        tmsOriginAddress: '',
        tmsDestinationAddress: ''
      },
      error: {
        // order details
        tmsDepartureTime: false,
        tmsFleetCategory: false,
        tmsFleetType: false,
        // origin and destination
        tmsOrigin: false,
        tmsDestination: false
      },
      today: moment().format('YYYY-MM-DD'),
      spinnerShow: false
    }
  },
  computed: {
    ...mapGetters({
      fleetCategoryDropdown: 'tms/fleetCategory',
      fleetTypeDropdown: 'tms/fleetType',
      isLoadingFleetType: 'tms/isLoadingFleetType',
      originCustomerDropdown: 'tms/originCustomer',
      destinationCustomerDropdown: 'tms/destinationCustomer',

      rfqData: 'rfq/item',
      isLoading: 'rfq/isLoading',
      isError: 'rfq/error'
    })
  },
  watch: {
    form: {
      handler(value) {
        const keys = Object.keys(value)
        keys.forEach(key => {
          if (value[key] && this.error[key]) {
            this.error[key] = false
          }
        })
      },
      deep: true
    },
    'form.tmsFleetCategory'(value) {
      if (value && this.rfqData) {
        this.$store.dispatch('tms/FETCH_FLEET_TYPE', this.form.tmsFleetCategory)
      }
    },
    fleetTypeDropdown(value) {
      if (this.rfqData) {
        this.form.tmsFleetType = value.filter(
          item => item.name === this.rfqData.tms_fleet_type
        )[0].name
      }
    },
    submitCheck(value) {
      if (value) {
        this.checkSubmit()
      }
    },
    rfqData(data) {
      if (data.service_head === 'LAND') {
        this.form.tmsFleetCategory = this.fleetCategoryDropdown.filter(
          item => item.name === data.tms_fleet_category
        )[0].name

        const origin = this.originCustomerDropdown.filter(
          item => item.name === data.tms_origin[0]
        )[0]
        const destination = this.destinationCustomerDropdown.filter(
          item => item.name === data.tms_destination[0]
        )[0]
        this.form.tmsOrigin = origin.name
        this.form.tmsDestination = destination.name
        this.form.tmsOriginCity = origin.city
        this.form.tmsDestinationCity = destination.city
        this.form.tmsOriginAddress = origin.address
        this.form.tmsDestinationAddress = destination.address
      }
    }
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.init()
      this.$eventHub.$on('duplicate-land', this.fetchRFQDetail)
    }
  },
  methods: {
    init() {
      this.$store.dispatch('tms/FETCH_FLEET_CATEGORY')
      this.$store.dispatch('tms/FETCH_ORIGIN_CUSTOMER')
      this.$store.dispatch('tms/FETCH_DESTINATION_CUSTOMER')
      this.$emit('inputData', this.form)
    },

    fetchRFQDetail(id) {
      this.$store.dispatch('rfq/FETCH_RFQ_BY_ID', id)
    },

    getDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    getMinimumToday() {
      return moment().format('YYYY-MM-DD HH:mm')
    },
    checkingMandatory() {
      const mandatoryKeys = Object.keys(this.error)
      mandatoryKeys.forEach(key => {
        if (!this.form[key]) {
          this.error[key] = true
        }
      })
      return Object.values(this.error).every(val => val === false)
    },
    handleChange(key, value) {
      if (key === 'tmsOrigin') {
        this.form.tmsOrigin = value.name
        this.form.tmsOriginCity = value.city
        this.form.tmsOriginAddress = value.address
      } else if (key === 'tmsDestination') {
        this.form.tmsDestination = value.name
        this.form.tmsDestinationCity = value.city
        this.form.tmsDestinationAddress = value.address
      } else if (key === 'tmsFleetCategory') {
        if (this.form.tmsFleetCategory !== value.name) {
          this.form.tmsFleetCategory = value.name
          this.form.tmsFleetType = ''
          this.$store.dispatch(
            'tms/FETCH_FLEET_TYPE',
            this.form.tmsFleetCategory
          )
        }
      }
    },
    checkSubmit() {
      const pass = this.checkingMandatory()
      if (pass) {
        this.$emit('callBackSubmit', this.form)
      } else {
        this.$emit('callBackSubmit', false)
      }
    }
  }
}
</script>

<style lang="scss">
.shipment_land {
  form p,
  .form-control,
  .custom-checkbox .custom-control-label {
    font-size: 14px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/requestShipment/newRequestShipment/FormShipmentLand.vue